import { History, Location } from "history";
import * as React from "react";
import { ReportLayout } from "./ReportLayout";
import { AdFormatOverviewReport, AdFormatDetailsList } from "@components";
import { ChartPlaceholder } from "@pages";

export interface CreativeReportPageProps {
    history: History;
    location: Location;
}

export function CreativeReportPage(props: CreativeReportPageProps) {
    return (
        <ReportLayout history={props.history} location={props.location} subtitle="Creative reports">
            <ChartPlaceholder className="no-bg" size="full">
                <AdFormatOverviewReport />
            </ChartPlaceholder>
            <AdFormatDetailsList />
        </ReportLayout>
    );
}
